import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { ModalDialog } from 'components/ModalDialog';
import { RequestStatus } from 'features/request/requestSlice';
import type { WorkOrderPriceRatioRowData } from 'gql/graphql';

import { useMemo } from 'react';

import type { IVariablesChangeData, IVariablesData } from '../WorkOrderUseCoefficient';

import { useRatioUerRowChangeItemsData } from './hooks/useRatioUerRowChangeItemsData';
import { useRatioUerRowItemsColumns } from './hooks/useRatioUerRowItemsColumns';
import { useRatioUerRowItemsData } from './hooks/useRatioUerRowItemsData';

export const GridRatioUerRowItems = ({
    rowPriceRatioData,
    closeRatioInfoTable,
    variablesData,
    isWorkOrderChange,
    variablesChangeData,
}: {
    rowPriceRatioData: WorkOrderPriceRatioRowData;
    closeRatioInfoTable: () => void;
    variablesData?: IVariablesData;
    isWorkOrderChange?: boolean;
    variablesChangeData: IVariablesChangeData;
}) => {
    const modalTitle = useMemo(() => `Расценки к коэффициенту ${rowPriceRatioData?.code}`, [rowPriceRatioData?.code]);

    const { isRootItem, workOrderObjectIds } = variablesData || {};

    const { rowData, fetchingStatus } = useRatioUerRowItemsData({
        ratioRowId: rowPriceRatioData?.id,
        isRootItem,
        workOrderObjectIds,
        isWorkOrderChange,
    });

    const { rowOrderChangeData, rowOrderChangeFetchingStatus } = useRatioUerRowChangeItemsData({
        ratioRowId: rowPriceRatioData?.id,
        isRootItem,
        variablesChangeData,
        isWorkOrderChange,
    });

    const { columns } = useRatioUerRowItemsColumns(isWorkOrderChange);

    const { rowGridData, fetchingStatusGridData } = useMemo(
        () => ({
            rowGridData: isWorkOrderChange ? rowOrderChangeData : rowData,
            fetchingStatusGridData: isWorkOrderChange ? rowOrderChangeFetchingStatus : fetchingStatus,
        }),
        [isWorkOrderChange, rowOrderChangeData, rowData, rowOrderChangeFetchingStatus, fetchingStatus],
    );

    return (
        <ModalDialog
            isOpen={!!rowPriceRatioData?.id}
            title={modalTitle}
            onClose={closeRatioInfoTable}
            isOnClickOutsideDisable
            btnCancelLabel="Закрыть"
            withTitleCloseButton
            bodyWidth={1000}
            btnCancelView="primary"
        >
            <div style={{ height: '45vh', padding: '20px' }}>
                <div style={{ height: '100%' }}>
                    <AgGridTable
                        loading={fetchingStatusGridData === RequestStatus.FETCHING}
                        columnDefs={columns}
                        rowData={rowGridData}
                        maxConcurrentDatasourceRequests={1}
                        maxBlocksInCache={50}
                        cacheBlockSize={50}
                    />
                </div>
            </div>
        </ModalDialog>
    );
};

GridRatioUerRowItems.displayName = 'GridRatioUerRowItems';
